'use strict';

import { range } from 'lodash';
import { Injectable, Inject } from 'ng-metadata/core';
import { timeout } from 'rxjs/operator/timeout';
import { getVid } from '../../../../appConfig/appConfigForward';
import { SharedSessionStorage } from '../../../../infra/sharedSessionStorage.service';
import { ResultUtil } from '../../../../nddUtils/resultUtil.service';
import { StringUtils } from '../../../../nddUtils/stringUtils.service';
import { JwtUtilService } from '../../../../security/jwtUtil.service';

const NUM_OF_PAGE_LINKS = 5;
const PAGES_TO_SHOW_50_BULK_WITHOUT_PAGE_BEFORE_OR_AFTER = 2;
const PAGES_TO_SHOW_50_BULK = 1;

@Injectable()
export class PageNavMenuService {

    private _pageInView: number;
    private _needToUpdatePivInSafari: boolean;
    private _startPage: number;
    private _PAGE_SIZE: number;
    private _numOfLoadedPagesVal: number;
    private _numOfResultsVal: number;
    private _maxDisplayResultsVal: number;
    private _currentPageVal: number;
    public availablePages: Array<number> = [];
    private vid = getVid();
    private _lowerRange: number;
    private _higherRange: number;
    private _currentPageNumVal: number;
    private _totalResultsVal: number;
    private userSettingsUrl: string;
    private _rangeTitle: string;
    private _page_size_temp: number;
    private _isCategoriesSearchVal: boolean;
    private _hasMoreResults: boolean;
    constructor( @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
        private jwtUtilService: JwtUtilService,
        private resultUtil: ResultUtil,
        private sharedSessionStorage: SharedSessionStorage,
        private stringUtils: StringUtils,
        @Inject('$http') private $http: ng.IHttpService,
        @Inject('restBaseURLs') private restBaseURLs,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService) {
        this.$http = $http;
        this.userSettingsUrl = restBaseURLs.userSettingsBaseURL;
    }

    get pageInView(): number {
        return this._pageInView;
    }

    set pageInView(updatedPage: number) {
        this._pageInView = updatedPage;
    }

    get needToUpdatePivInSafari(): boolean {
        return this._needToUpdatePivInSafari;
    }

    set needToUpdatePivInSafari(isNeedToUpdate: boolean) {
        this._needToUpdatePivInSafari = isNeedToUpdate;
    }

    get startPage(): number {
        return this._startPage;
    }

    set startPage(startPage: number) {
        this._startPage = startPage;
    }

    get PAGE_SIZE(): number {
        return this._PAGE_SIZE;
    }

    set PAGE_SIZE(PAGE_SIZE: number) {
        this._PAGE_SIZE = PAGE_SIZE;
    }

    get numOfLoadedPagesVal(): number {
        return this._numOfLoadedPagesVal;
    }

    set numOfLoadedPagesVal(numOfLoadedPagesVal: number) {
        this._numOfLoadedPagesVal = numOfLoadedPagesVal;
    }

    get numOfResultsVal(): number {
        return this._numOfResultsVal;
    }

    set numOfResultsVal(numOfResultsVal: number) {
        this._numOfResultsVal = numOfResultsVal;
    }

    get maxDisplayResultsVal(): number {
        return this._maxDisplayResultsVal;
    }

    set maxDisplayResultsVal(maxDisplayResultsVal: number) {
        this._maxDisplayResultsVal = maxDisplayResultsVal;
    }

    get currentPageVal(): number {
        return this._currentPageVal;
    }

    set currentPageVal(currentPageVal: number) {
        this._currentPageVal = currentPageVal;
    }

    get currentPageNumVal(): number {
        return this._currentPageNumVal;
    }

    set currentPageNumVal(currentPageNumVal: number) {
        this._currentPageNumVal = currentPageNumVal;
    }

    get totalResultsVal(): number {
        return this._totalResultsVal;
    }

    set totalResultsVal(totalResultsVal: number) {
        this._totalResultsVal = totalResultsVal;
    }

    get lowerRange(): number {
        return this._lowerRange;
    }

    set lowerRange(value: number) {
        this._lowerRange = value;
    }

    get higherRange(): number {
        return this._higherRange;
    }

    set higherRange(value: number) {
        this._higherRange = value;
    }

    get maxPage() {
        let ret = Math.ceil(this.numOfResultsVal / this.PAGE_SIZE);
        if (this.hasMoreResults) {
            return ret + 1;
        }
        return ret;
    }

    get maxDisplayPage() {
        return Math.ceil(this.maxDisplayResultsVal / this.PAGE_SIZE);
    }

    get rangeTitle() {
        return this._rangeTitle;
    }

    set rangeTitle(rangeTitle: string) {
        this._rangeTitle = rangeTitle;
        this.triggerTitleUpdate();
    }

    get page_size_temp() {
        return this._page_size_temp;
    }

    set page_size_temp(page_size_temp: number) {
        this._page_size_temp = page_size_temp;
    }

    get isCategoriesSearchVal(): boolean {
        return this._isCategoriesSearchVal;
    }

    set isCategoriesSearchVal(isCategoriesSearchVal: boolean) {
        this._isCategoriesSearchVal = isCategoriesSearchVal;
    }

    get hasMoreResults(): boolean {
        return this._hasMoreResults;
    }

    set hasMoreResults(val: boolean) {
        this._hasMoreResults = val;
    }

    public saveNumOfPageToLocalForage(size: number) {
        let resultsPerPage = size;
        let user = this.jwtUtilService.getDecodedToken().user;
        this.sharedSessionStorage.setItem('resultsBulkSize', size.toString());
        this.resultUtil.updatedBulkSize = size;
    }

    public updateBulkSizePerPageInDB(size: number) {
        let payload = {
            'vid': this.vid,
            'resultsBulkSize': size
        };
        this.$http.post(this.userSettingsUrl, payload).then(
            (response) => { },
            (error) => {
                return this.failurePostAction(error);
            }
        );
    }


    private failurePostAction(reason) {
        console.error(reason);
        return reason;
    }

    public initPageList() {
        if (this.PAGE_SIZE == 0) {
            this.PAGE_SIZE = this.page_size_temp;
        }
        let offset = this.$stateParams['offset'] ? this.$stateParams['offset'] : 0;
        this.startPage = Math.floor(offset / this.PAGE_SIZE) + 1;
        let loadedPageNum = this.startPage + this.numOfLoadedPagesVal - 1;
        let numOfSidePages = Math.floor(NUM_OF_PAGE_LINKS / 2);
        let pagesBeforeStartPage = Math.min(loadedPageNum - numOfSidePages + 1, numOfSidePages);
        let pagesAfterStartPage = numOfSidePages + (numOfSidePages - pagesBeforeStartPage);
        pagesBeforeStartPage += numOfSidePages - Math.min(this.maxPage - loadedPageNum, numOfSidePages);
        if (this.PAGE_SIZE === 50) {
            pagesBeforeStartPage = this.startPage === this.maxPage ? PAGES_TO_SHOW_50_BULK_WITHOUT_PAGE_BEFORE_OR_AFTER : PAGES_TO_SHOW_50_BULK;
            pagesAfterStartPage = this.startPage === 1 ? PAGES_TO_SHOW_50_BULK_WITHOUT_PAGE_BEFORE_OR_AFTER : PAGES_TO_SHOW_50_BULK;
        }

        let maxDisplayPage = this.maxPage;
        if (this.maxDisplayPage) {
            maxDisplayPage = Math.min(this.maxDisplayPage, this.maxPage);

        }

        this.availablePages = range(Math.max(loadedPageNum - pagesBeforeStartPage, 1), Math.min(loadedPageNum + pagesAfterStartPage, maxDisplayPage) + 1);
        if (this.currentPageVal > this.maxDisplayPage) {
            this.availablePages = [this.maxDisplayPage];
        }
    }

    public getResultNumberRange() {
        let page_size = this.PAGE_SIZE;
        if (page_size == 0) {
            page_size = this.page_size_temp;
        }
        let higherRangeValue = this.currentPageNumVal * page_size;
        if (higherRangeValue > this.totalResultsVal && !this.hasMoreResults) {
            this.higherRange = this.totalResultsVal;
            this.lowerRange = higherRangeValue - page_size + 1;
        }
        else {
            this.higherRange = higherRangeValue;
            this.lowerRange = this.higherRange - page_size + 1;
        }
    }

    public updateRangeTitle() {
        this.updateSelectedText();
    }

    public updateSelectedText() {
        if (!this.totalResultsVal || !this.lowerRange || !this.higherRange) {
            this.rangeTitle = "";
            return;
        }
        let norm_lang = this.$translate.use().replace("_", "-"); //Numbers in each language may have a different seperators (comma, space, dot,...)
        norm_lang = norm_lang === 'pt1' ? 'pt-PT' : norm_lang;  // URM-231457
        let resultsRange = this.lowerRange.toLocaleString(norm_lang) + '-' + this.higherRange.toLocaleString(norm_lang);
        if (this.isCategoriesSearchVal) {
            this.rangeTitle = resultsRange;
        }
        else if (this.isBrowseSearch() && this.isBrowseSearchPagingEnabled()) {
            // In browse search with paging enbled, we don't know the exact total and therefore don't display it
            let placeHolders = {
                resultsRange: resultsRange
            };
            this.$translate('nui.results.title.resultsDisplayedNoTotal', placeHolders).then((translation) => {
                this.rangeTitle = this.stringUtils.decode(translation);
            });
        } else {
            let startTime = Date.now();
            this.checkTranslation(startTime);
        }
    }

    private checkTranslation(startTime) {
        let elapsedTime = Date.now() - startTime;
        if (!this.$translate.isReady() && elapsedTime < 10000) {
            setTimeout(() => {
                this.checkTranslation(startTime); // Check again after a delay
            }, 10); 
        } 
        else {
            let norm_lang = this.$translate.use().replace("_", "-"); //Numbers in each language may have a different seperators (comma, space, dot,...)
            norm_lang = norm_lang === 'pt1' ? 'pt-PT' : norm_lang;  // URM-231457
            let resultsRange = this.lowerRange.toLocaleString(norm_lang) + '-' + this.higherRange.toLocaleString(norm_lang);
            let placeHolders = {
                resultsRange: resultsRange,
                totalNumberOfResults: this.totalResultsVal.toLocaleString(norm_lang)
            };
            this.$translate('nui.results.title.resultsDisplayed', placeHolders).then((translation) => {
                this.rangeTitle = this.stringUtils.decode(translation + ' ' + this.$translate.instant('results.title'));
            });
        }
    }

    private isBrowseSearchPagingEnabled(): boolean {
        return window.appConfig['system-configuration']['primo_ve_enable_browse_search_paging'];
    }

    private isBrowseSearch(): boolean {
        return !!this.$stateParams.browseParams;
    }
    
    private triggerTitleUpdate() {
        if (this.PAGE_SIZE === 0) {
            return;
        }
        this.page_size_temp = this.PAGE_SIZE;
        this.PAGE_SIZE = 0;
        this.$timeout(() => { //simulate change in md-select
            this.PAGE_SIZE = this.page_size_temp;
        }, 0);
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/pageNavMenu/pageNavMenu.service.ts